<p>add-accessory-crossbar works!</p>
